angular.module('dpw.services').factory('dpwLeadsReportService', [
    '$q', 'api', 'helpers', function ($q, api, helpers) {
        var store = {
            inputCriteria: {
                appProfileName: '',
                beginTime: '',
                endTime: '',
                sortObj: {createTime: false}
            },
            usedCriteria: {},
            hasSearched: false,
            searchResult: [],
            paging: null
        };

        function formatCriteria(criteria) {

            var copy = angular.copy(criteria);
            copy.beginTime = moment(copy.beginTime || '2018-01-01').startOf('day').utc().toISOString();
            copy.endTime = moment(copy.endTime || moment()).endOf('day').utc().toISOString();

            return copy;
        }

        return {
            store: store,
            search: function () {
                return $q(function (resolve, reject) {
                    api.call(api.leadsReport.search(formatCriteria(store.usedCriteria), store.paging),
                        function (data) {
                            store.hasSearched = true;
                            store.searchResult = data.leads;
                            resolve(data);
                        }, function (err, defaultHandler) {
                            reject({
                                err: err,
                                defaultHandler: defaultHandler
                            });
                        });
                });
            },
            isVisible: function () {
                return $q(function (resolve, reject) {
                    api.call(api.leadsReport.isVisible(),
                        function (data) {
                            resolve(data.result);
                        }, function (err, defaultHandler) {
                            reject({
                                err: err,
                                defaultHandler: defaultHandler
                            });
                        });
                });
            },
            export: function (name) {
                var tzOffset = -new Date().getTimezoneOffset() * 60;
                var offset = encodeURIComponent(tzOffset > 0 ? ('+' + tzOffset) : tzOffset);
                window.location = helpers.XSRFProtect('/api/leads/export.csv?exportName=' + name + '&offset=' + offset + '&' + helpers.handleExportParams(formatCriteria(store.usedCriteria)));
            }
        };

    }
]);
